import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { RestaurantService } from '../services/restaurant.service';
import {
  isRouteAllowedForPlan,
  PLAN_MENU_DEFAULT_ROUTE,
} from '../utils/subscription-plan-menu.util';

/**
 * Restricts `/main` child routes to what the restaurant's subscription plan
 * (Free/Standard/Premium) includes, once the restaurant is fully `activated`.
 * A `published`-but-not-activated restaurant is already restricted by
 * RestaurantStatusGuard; this guard only layers its own check on top for an
 * `activated` restaurant.
 */
export const SubscriptionPlanGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const restaurantService = inject(RestaurantService);

  if (restaurantService.currentRestaurantDetails$.value?.status !== 'activated') {
    return true;
  }

  const path = route.routeConfig?.path || '';
  if (isRouteAllowedForPlan(path, restaurantService.currentPlanName$.value)) {
    return true;
  }

  return router.createUrlTree(['main', PLAN_MENU_DEFAULT_ROUTE]);
};
